export default "__VITE_ASSET__D8$x8UNg__"